<!-- TEMPLATE CONTRACT: Ui Page Header Component owns the visible Angular template structure for src/app/shared/ui/ui-page-header/ui-page-header.component.html. -->
<header class="ui-page-header">
  <div class="ui-page-header__actions" role="group" [attr.aria-label]="actionsAriaLabel() | uiLabelTranslate">
    <ng-content />
  </div>
</header>
